import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { UpProviderProvider } from './utils/upProviderContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <UpProviderProvider>
      <App />
    </UpProviderProvider>
  </React.StrictMode>
);
